import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderTelehealthJoinLink: build.mutation<
      PostV2ProviderTelehealthJoinLinkApiResponse,
      PostV2ProviderTelehealthJoinLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/telehealth/join-link`,
        method: "POST",
        body: queryArg.joinLinkRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderTelehealthJoinLinkApiResponse =
  /** status 200 OK */ JoinLinkResponse;
export type PostV2ProviderTelehealthJoinLinkApiArg = {
  joinLinkRequest: JoinLinkRequest;
};
export type JoinLinkResponse = {
  /** Token expiration time */
  expires_at?: string | null;
  /** Whether this token grants owner privileges */
  is_owner: boolean;
  /** Daily room name */
  room_name: string;
  /** Daily room URL */
  room_url: string;
  /** Meeting token for joining the room */
  token: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type JoinLinkRequest = {
  /** Appointment ID to get join link for */
  appointment_id: string;
};
